<div [hidden]="!viewCondition" class="image">
    <img [src]="imageUrl"/>
</div>
